import * as types from '@store/types'
import request from '@queries'
import axios from 'axios'

import CashbackQuery from '@queries/Cashback'

const state = {
  cashbacks: [],
  pagination: { }
}

const getters = {
  [types.CASHBACKS]: ({ cashbacks }) => {
    return cashbacks.map((cashback) => ({
      ...cashback,
      total: (cashback.total / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
      user_comission: (cashback.user_comission / 100).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    }))
  },
  [types.CASHBACK_PAGINATE]: ({ pagination }) => ({ ...pagination })
}

const mutations = {
  [types.CASHBACKS]: (state, { data: list, ...pagination }) => {
    state.cashbacks = [...list]
    state.pagination = { ...pagination }
  },
  [types.CASHBACK_PAGINATE]: (state, { data: list, ...pagination }) => {
    state.cashbacks = [...state.cashbacks, ...list]
    state.pagination = { ...pagination }
  },
  [types.CASHBACK_CREATE]: (state, payload) => {

  }
}

const actions = {
  [types.CASHBACKS]: async ({ commit }, variables) => {
    const response = await request(CashbackQuery, { ...variables })
    const pagination = response.data.data.pagination || {}

    commit(types.CASHBACKS, pagination)
  },
  [types.CASHBACK_PAGINATE]: async ({ commit }, variables) => {
    const response = await request(CashbackQuery, { ...variables })
    const pagination = response.data.data.pagination || {}

    commit(types.CASHBACK_PAGINATE, pagination)
  },
  [types.CASHBACK_CREATE]: async ({ commit, dispatch }, variables) => {
    try {
      const url = 'perks/cashback'
      const response = await axios.post(url, variables)

      const message = { type: 'success', text: 'Resgate realizado com sucesso' }
      dispatch(types.FEEDBACK, message)
    } catch (e) {
      let text = ''
      if (e.response && e.response.data) text = e.response.data.message

      const message = { type: 'error', text }
      dispatch(types.FEEDBACK, message)
    }
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/cashback.js